module.exports = __webpack_public_path__ + "static/media/HMPSA UNPAR.4db32f76.png";